import React, { Component } from 'react';
import Header from '../.././Header';
import Image from '../.././Image';
import classnames from 'classnames';

export default class Tutorific extends Component {
  // static propTypes = {}
  // static defaultProps = {}
  // state = {}

  render() {
    const { className } = this.props;

    const navLinks = [
      {path: "/projects", title: "Projects"}
    ]

    const slug = "tutorific";
    const screenshots = [
      {id: 'tutorific-1', title: 'Tutorific', content: 'A simple well-spaced font against a clean and professional blue color scheme, designed to give a semi-formal appearance. Tutorific is a play on the words tutor and terrific. Font used: Vegur.'},
      {id: 'tutorific-2', title: 'Landing Page', content: 'A landing page with a clear call to action and instructions for creating a profile. The target audience was tutors that already knew about the service, so the language here was deliberately straightforward.'},
    ];

    return (
      <div className={classnames('Tutorific', className)}>
        <Header links={navLinks} />
        <div className="container">
          <div className="section">
            <div className="section-content">
              <div className="section-header">Tutorific</div>
              <div className="section-title">Description</div>
              <div className="section-copy">
                <ul>
                  <li><strong>Objective</strong>: Match high school students with college tutors</li>
                  <li><strong>Role</strong>: Co-founder</li>
                  <li><strong>Team</strong>: Weiyu Ng</li>
                  <li><strong>Duration</strong>: Jun 2009—Dec 2009 (7 months)</li>
                </ul>
              </div>
              <div className="section-title">Highlights</div>
              <div className="section-copy">
                <ul>
                  <li>Co-founded a private tutor agency for college students</li>
                  <li>Designed and developed Tutorific, a web application for tutors to create profiles, making it easier to search our database</li>
                  <li>Grew the service to over 100 registered tutors and was cashflow positive after six months</li>
                </ul>
              </div>
              <div className="section-title">Summary</div>
              <div className="section-copy">
                <p>
                  In my second year in college, Weiyu Ng and I started a private tutor agency to match undergraduate tutors to high school students. The service started off with a few friends but eventually signed up over 100 students at our college. For tutees, we ran weekly advertisements in local newspapers and liaised with parents and students who called in.
                </p>
                <p>
                  <strong>Problem:</strong> As more tutors joined and more parents called in, we had difficulty maintaining and searching our list of available tutors, which led to a inefficient matching process that took a lot of time. With different subjects and varying tutoring rates, it was difficult to keep track and onboard new tutors.
                </p>
                <p>
                  <strong>Approach:</strong> Tutorific is a web application that I built for tutors to create profiles with the agency. This profile included their contact details, subject expertise, location preferences and past tutoring experiences. With Tutorific, we could easily search the database for suitable tutors by filtering for the necessary criteria.
                </p>
                <p>
                  Unfortunately, having to coordinate between tutors and students took up too much time, and this became unsustainable as the service grew. On hindsight, a better strategy would have been to build a two-sided marketplace to facilitate this coordination. The company was cashflow positive when we shut it down.
                </p>
              </div>
              <div className="section-title">Designs</div>
              <div className="section-images">
                {
                  Object.keys(screenshots).map(function(key) {
                    return (
                      <Image slug={slug} id={screenshots[key]['id']} title={screenshots[key]['title']} content={screenshots[key]['content']} />
                    )
                  })
                }
              </div>
              <div className="section-title">Tech / Tools</div>
              <div className="section-copy">
                <ul>
                  <li>Designed in Adobe Photoshop</li>
                  <li>Built with PHP on CodeIgniter, MySQL, HTML and CSS</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Projects/Tutorific/index.js